import { actionCreator } from '@ardoq/rxbeach';
import { UpdateViewEmptyStateDataPayload } from './types';

export const updateViewEmptyStateData =
  actionCreator<UpdateViewEmptyStateDataPayload>(
    '[emptyState] update view empty state data'
  );
